<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">سجل الأخطاء</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">سجل الأخطاء</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <div v-if="!isLoading" class="row">
          <div v-if="checkAccess('error_logs_delete')" class="col text-end">
            <button v-if="checkAccess('users_export')" type="button" class="btn btn-success me-2" @click.prevent="exportExcel">
              <i class="fa fa-file-excel me-1"></i> تصدير Excel
            </button>
            <button type="button" class="btn btn-danger" @click="deleteAllItem"><i class="fa-regular fa-trash-can"></i> حذف جميع الاخطاء</button>
          </div>
        </div>
        <!--begin::Row-->
        <div v-if="isLoading" class="text-center align-content-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center mb-4 mt-5">
          <div class="col-12 col-md-11">
            <errorAlert v-if="hasError" :alertMessage= "message" />
            <table class="table table-striped table-hover text-center">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">رقم الخطأ</th>
                  <th scope="col">الرسالة</th>
                  <th scope="col">تاريخ الإنشاء</th>
                  <th scope="col">التفاصيل</th>
                  <th v-if="checkAccess('error_logs_delete')" scope="col">الحذف</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,index) in rows" :key="index">
                  <td class="counter"></td>
                  <td>{{ row.errorNum }}</td>
                  <td>{{ row.message }}</td>
                  <td class="date-format">{{ formatDate(row.createdAt) }}</td>
                  <td>
                    <router-link :to="'/errorview/'+row.id">
                      <i class="bi bi-card-list"></i>
                    </router-link>
                  </td>
                  <td v-if="checkAccess('error_logs_delete')">
                    <a @click.prevent="deleteItem(index, row.id)">
                      <i class="bi bi-archive text-red pointer-mouse"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-12 pt-3">
            <div class="row">
              <div class="col">
                <ul class="pagination">
                  <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                  <li v-for="p in pages" :key="p" class="page-item">
                    <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                    <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                  </li>
                  <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { toast, checkAccess, formatDate } from '@/helpers/tools';

export default {
  name: "errorlogs",
  data(){
    return {
      hasError: false,
      message: "",
      isLoading: false,
      rows: [],
      currentPage: 1,
      pages: [],
    }
  },
  methods: {
    checkAccess, 
    formatDate, 
    errorList() {
      this.hasError = false;
      this.isLoading = true;
      this.$http.get(`/api/admin/errorLogs/list?page=${this.currentPage}`).then(res => {
        this.rows = res.data.errorLogs;
        this.pages = res.data.pages ?? [this.currentPage];
        this.isLoading = false;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },

    async deleteItem(index, id) {
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.delItem(index, id);
      }
    },

    // Helper function to actually delete the image
    delItem(index, id) {
      this.$http.delete(`/api/admin/errorLogs/delete/${id}`).then(res => {
        // Remove the image from both arrays
        let buffer = this.rows;
        buffer.splice(index, 1);
        this.rows = buffer;
        toast('تم حذف السجل بنجاح', 'success');
      }).catch(err => {
        toast('غير قادر على حذف السجل');
      })
    },

    async deleteAllItem(index, id) {
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد جميع السجلات ، لا يمكن استعادتها مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if(deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/errorLogs/deleteAll`).then(res => {
          this.errorList();
          toast('تم حذف السجل بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على حذف السجل');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.errorList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.errorList();
    },
    goToPage(num){
      this.currentPage = num;
      this.errorList();
    },
    async exportExcel(){
      try {
        const response = await this.$http.get('/api/admin/errorLogs/export', { responseType: 'blob' });
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'errorsLog.xlsx';
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (err) {
        toast('فشل تصدير الملف', 'error');
      }
    },
  },
  created() {
    this.errorList();
  }
}
</script>